import { Droplet, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function NozzlesPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Nozzles</h1>
          <p className="text-sm text-foreground-muted">Manage your nozzle inventory</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add Nozzle
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Droplet className="h-10 w-10" />}
          title="No nozzles yet"
          description="Track your nozzle inventory including sizes, materials, and condition."
          actionLabel="Add Nozzle"
          onAction={() => {
            // TODO: Open add nozzle modal
          }}
        />
      </div>
    </div>
  );
}
